import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Launch16 from '@carbon/icons-react/es/launch/16';
import { Menu } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { withHideIfNotAllowed } from 'components/organisms/permission-controller';
const MenuItem = styled(Menu.Item)`
  a {
    display: flex;
    align-items: center;
    gap: var(--spacing-04);
    color: var(--primary-color);
  }
  span {
    flex: 1;
  }
`;
const BaseLink = (params)=>{
    const { icon = /*#__PURE__*/ _jsx(Launch16, {}), children, linkTo } = params;
    return /*#__PURE__*/ _jsx(MenuItem, {
        ...params,
        children: /*#__PURE__*/ _jsxs("a", {
            href: linkTo,
            target: "_blank",
            rel: "noreferrer",
            children: [
                icon,
                " ",
                children
            ]
        })
    });
};
export const Link = withHideIfNotAllowed(BaseLink);
